module.exports = __webpack_public_path__ + "static/media/mobile.5b3e27ea.svg";